<template>
    <el-button type="text" :loading="loading" :disabled="disabled" @click="handleClick">
        {{ countdown > 0 ? `${disabledText}` : text }}
    </el-button>
</template>

<script>
export default {
    name: 'SySmsButton',
    props: {
        /**
         * 接受验证码的电话号码
         */
        phone: {
            type: String,
            default: ''
        },
        /**
         * 是否需传手机号码
         */
        ifPhone:{
            type: Boolean,
            default: true
        },
        /**
         * 验证码发送间隔,单位秒
         */
        interval: {
            type: Number,
            default: 60
        },
        /**
         * 按钮文本
         */
        text: {
            type: String,
            default: '发送验证码'
        },
        /**
         * 倒计时按钮文本
         */
        countdownText: {
            type: String,
            default: '已发送 ${n} S'
        },
        /**
         * 发送验证码函数,需返回promise
         */
        sendSms: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            // 加载状态
            loading: false,
            // 倒计时
            countdown: 0,
            // 计时器
            timer: null
        };
    },
    computed: {
        /**
         * 发送验证码按钮是否可用
         */
        disabled() {
            if (this.countdown > 0) {
                return true;
            }

            if (!/^(1)[3-9][0-9]{9}$/.test(this.phone) && this.ifPhone) {
                return true;
            }
            return false;
        },
        /**
         * 禁用时按钮文本
         */
        disabledText() {
            return this.countdownText.replace('${n}', this.countdown);
        }
    },
    destroyed() {
        if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
        }
    },
    methods: {
        /**
         * 处理点击事件
         */
        handleClick() {
            if (this.countdown > 0) {
                // 重新发送验证码倒计时期间不重新发送请求
                return;
            }

            this.loading = true;
            this.sendSms()
                .then(res => {
                    this.loading = false;
                    if (res.data.code === 99020046) {
                        this.$message.success(res.data.message);
                    } else if (res.data.code === 200) {
                        this.$message.success('验证码已成功发送!');
                    } else {
                        this.$message.error('验证码发送失败!');
                    }
                    this.countdown = this.interval - 1;
                    this.timer = window.setInterval(this.timerInterval, 1000);
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.message || '发送验证码失败!');
                });
        },
        /**
         * 计时器执行的行数
         */
        timerInterval() {
            if (this.countdown === 0) {
                window.clearInterval(this.timer);
                this.timer = null;
            } else {
                this.countdown -= 1;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.ellipsis-Text {
    position: relative;

    .display-div {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .actual-div {
        position: absolute;
        overflow: visible;
        white-space: nowrap;
        opacity: 0;
    }
}
</style>
